import {createSelector} from 'reselect';

export const getChangePassword = ({forceChangePassword}) => forceChangePassword;
export const getisChangedPasswordSuccess = createSelector(
  getChangePassword,
  (forceChangePassword) => forceChangePassword.isChangedPasswordSuccess,
);
